type Symbols = '' | 'k' | 'M' | 'G' | 'T' | 'P' | 'E';

const SI_SYMBOL: Symbols[] = ['', 'k', 'M', 'G', 'T', 'P', 'E'];

const MAX_UNFORMATTED_NUMBER = 10000;

const abbreviateNumber = (num: number, fixed: number) => {
  const number = num || 0;
  const tier = (Math.log10(number) / 3) | 0;

  if (tier === 0 || number < MAX_UNFORMATTED_NUMBER) {
    return number.toFixed(fixed);
  }

  const suffix = SI_SYMBOL[tier];
  const scale = Math.pow(10, tier * 3);
  const scaled = number / scale;

  return scaled.toFixed(fixed) + suffix;
};

const removeSpecialCharsAndUpperCase = (word: string): string => {
  return removeSpecialChars(word).toUpperCase();
};

const removeSpecialChars = (word: string): string => {
  return word.replace(/[^a-z0-9]/gi, '');
};

export { abbreviateNumber, removeSpecialChars, removeSpecialCharsAndUpperCase };
